<template>
  <ui-card
    name="audience.moment_tracker"
    class="has-shadow"
    padded
    rounded
    :error="error"
  >
    <moment-tracker-tabs slot="controls" />

    <div class="columns is-multiline is-gapless">
      <div
        class="column"
        :class="getTileClass(index)"
        v-for="(item, index) in items"
        :key="index"
      >
        <moment-tracker-item
          :config="item"
          :class="getComponentClass(index)"
          @node-hover="onNodeHover"
          @node-click="onNodeClick"
        />
      </div>
    </div>

    <moment-popup
      v-show="popupData"
      :data="popupData"
      :position="popupPosition"
    />
  </ui-card>
</template>

<script>
import MomentTrackerTabs from './MomentTrackerTabs';
import MomentTrackerItem from './MomentTrackerItem';
import MomentPopup from './MomentPopup';
import { map, assignIn } from 'lodash';
import { mapState } from 'vuex';
import bus from 'store/busses/AudienceBus';

const presentItems = [
  { key: 'moments', value: 'home' },
  { key: 'moments', value: 'working_at_work' },
  { key: 'events', value: 'car' },
  { key: 'events', value: 'walking' },
  { key: 'moments', value: 'morning' },
  { key: 'moments', value: 'commute_from_work' },
];
const pastItems = presentItems;

const futureItems = [
  { key: 'events', value: 'home' },
  { key: 'events', value: 'work' },
  { key: 'events', value: 'car' },
  { key: 'events', value: 'walking' },
  { key: 'events', value: 'regular' },
  { key: 'events', value: 'train' },
];

export default {
  name: 'MomentTracker',

  components: {
    MomentTrackerTabs,
    MomentTrackerItem,
    MomentPopup,
  },

  props: {
    cols: {
      type: Number,
      default: 3,
    },
  },

  data() {
    return {
      bus,
      futureItems: futureItems,
      pastItems: pastItems,
      presentItems: presentItems,
      popupData: null,
      popupPosition: null,
    };
  },

  computed: {
    ...mapState('audience', ['activeTrackerCategory']),

    items() {
      const category = this.activeTrackerCategory;

      let items = this[`${category}Items`];

      items = map(items, item => assignIn({}, item, { category }));

      return items;
    },

    error() {
      const audience = this.$store.state.audience;
      if (audience.filters.length && audience.users.length === 0) {
        return 'no_results';
      }

      return '';
    },
  },

  methods: {
    getTileClass() {
      const span = 12 / this.cols;
      return {
        ['is-' + span]: true,
      };
    },

    getComponentClass(index) {
      const cols = this.cols;
      return {
        'has-border-top': index >= cols,
        'has-border-left': index % cols,
        'is-paddingless-right': index % cols === 2,
      };
    },

    onNodeHover(user, pos) {
      this.bus.setUser(user);
      this.popupData = this.bus.data;
      this.popupPosition = pos;
    },

    onNodeClick(user) {
      this.$router.push({ name: 'audience-user', params: { userId: user.id } });
      this.bus.setUser(null);
      this.popupData = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.card {
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  box-shadow: 0 2px 4px 0 rgba($black, 0.08);
}

.tabs {
  &:not(:last-child) {
    margin-bottom: 0;
    margin-right: 0.5rem;
  }
}

.columns {
  flex: 1;

  &.is-gapless {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
}

.column {
  display: flex;
}

.moment-tracker-item {
  flex: 1;
  padding-right: 1rem;

  &:not(.has-border-top) {
    padding-bottom: 1rem;
  }

  &.has-border-top {
    padding-top: 1rem;
    border-top: 1px solid #e0e0e0;
  }

  &.has-border-left {
    padding-left: 1rem;
    border-left: 1px solid #e0e0e0;
  }

  &.is-paddingless-right {
    padding-right: 0;
  }
}
</style>
